module.exports = __webpack_public_path__ + "static/img/radio_on.b5dccc5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/radio_on.svg
// module id = 4zSv
// module chunks = 10